import { render, staticRenderFns } from "./customer-iv-managementInfo.vue?vue&type=template&id=11b31710"
import script from "./customer-iv-managementInfo.vue?vue&type=script&lang=ts"
export * from "./customer-iv-managementInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports